module.exports = __webpack_public_path__ + "img/main_decoration.0759cae2.svg";